import { useEffect, useState } from "react"
import { useSelector, useDispatch } from 'react-redux';
import { FetchHandler } from "../../Handlers/FetchHandler";
import { LocalStore } from "../../Handlers/LocalStore";
import { RdxStore } from "../../rdx/ReduxTypes";
import { PlantTypeType } from "../../rdx/Redux.DataReducerType";



const ALL_LANGUAGES = [
    // "sv", 
    "no", "en", "en-us"];

export const useTranslationsManager = () => {
    const ss: PlantTypeType[] = useSelector((state: RdxStore) => state.data.planttypes);
    const types: { value: string, label: string }[] = ss.map(o => { return { value: o.id, label: o.name } });

    //const options = [{ value: "-", label: "Inget filter" }].concat(types);


    const [loading, setLoading] = useState<boolean>(false);
    const [db, setDB] = useState<Record<string, PlantTranslationType>>({});
    const [dataRaw, setDataRaw] = useState<PlantTranslationType[]>([]);
    const [dataFiltered, setDataFiltered] = useState<PlantTranslationType[]>([]);
    const [languages, setLanguages] = useState<string[]>(ALL_LANGUAGES);

    const sortFunction = (a: PlantTranslationType, b: PlantTranslationType) => {
        const ak = a?.[sort?.field];
        const bk = b?.[sort?.field];
        const d = sort?.direction ?? "asc";

        if (ak > bk) { return d == "asc" ? 1 : -1; }
        else if (ak < bk) { return d == "asc" ? -1 : 1; }
        else { return 0; }

    }
    const [plantTypeId, setPlantTypeId] = useState<string>("ee4384cb-6220-41f7-9c7d-f3a9b2b0e621")

    const load = async () => {
        setLoading(true);
        let ret: PlantTranslationType[] = await FetchHandler.getJson("/api/translationplants?type=" + plantTypeId);

        ret.sort(sortFunction);

        setDataRaw(ret);

        setDataFiltered(ret.filter((n, idx) => idx < 100));

        setLoading(false);


    }


    const missing = (e: string) => {
        setDataFiltered(dataRaw.filter(m => !m?.[e]));
    }
    const resetFilter = () => {
        setDataFiltered(dataRaw.filter((n, idx) => idx < 100));
    }
    const filterName = (e: string) => {
        const f = e?.toLowerCase() ?? "";
        setDataFiltered(dataRaw.filter((n, idx) => {
            return n?.name?.toLowerCase()?.includes(f)
        }));
    }

    const [changes, setChanges] = useState<any>({});

    const addUpdate = (e: PlantTranslationType, field: string, value: string) => {
        const id = e?.id;
        const _value = value?.trim();
        let _new = { ...changes };
        if ((e?.[field] ?? "") !== (_value ?? "")) {
            _new[id] = { ..._new[id], [field]: _value };
        } else {
            if (_new?.[id]?.hasOwnProperty(field)) {
                delete _new[id][field];
            }
            if (Object.keys(_new?.[id] ?? {}).length == 0 && !!_new[id]) {
                delete _new[id];
            }
        }
        setChanges(_new);
    }
    const saveChanges = async () => {
        const url = "/api/translationplants/save";
        const success: boolean = await FetchHandler.patchJson(url, changes);
        if (success === true) {
            setChanges({})
        }
    }

    // *********************** Sort ***********************
    const [sort, setSort] = useState<{ field?: string, direction?: "asc" | "desc" }>({ field: "name", direction: "asc" });


    const reSort = async () => {
        setLoading(true);
        let ret: PlantTranslationType[] = dataRaw;
        ret.sort(sortFunction);
        setDataRaw(ret);
        setDataFiltered(ret.filter((n, idx) => idx < 100));
        setLoading(false);
    }
    useEffect(() => {
        reSort();
    }, [sort])

    // *********************** plantTypeId ***********************

    return {
        loading,
        dataRaw,
        dataFiltered,
        load,

        missing,
        resetFilter,
        filterName,
        addUpdate,
        changes,
        saveChanges,
        sort, setSort: (e: string) => {
            if (sort.field === e) {
                setSort({ ...sort, direction: sort?.direction === "asc" ? "desc" : "asc" });
            } else {
                setSort({ field: e, direction: "asc" })
            }
        },
        plantTypes: types,
        plantTypeId, setPlantTypeId,
        ALL_LANGUAGES,
        languages: languages,
        setLanguages: (e: string) => {
            if (languages.indexOf(e) >= 0) {
                setLanguages(languages.filter(m => m !== e));
            } else {
                setLanguages([...languages, e]);
            }
        },

        editFields: [
            { value: "name", label: "Namn" },
            { value: "sort", label: "Sort" },
            { value: "description", label: "Beskrivning" },
        ]


    }
}

export type PlantTranslationType = {
    id: string
    name: string
    name_no: string
    name_en: string
    name_en_us: string

    specifictype: string
    specifictype_no: string
    specifictype_en: string

    namelatin: string
    familyname: string
    public_description: string

}

